<script>
	import { fly } from 'svelte/transition'
	import { sineInOut } from 'svelte/easing'
	import { onMount } from 'svelte'
	// import next from 'array-next'

	export let bannerQuotes = []
	export let classQuotes = []
	export let theatreQuotes = []

	let activeQuote = bannerQuotes[0]
	let activeClassQuote = classQuotes[0]
	let activeTheatreQuote = theatreQuotes[0]

	let showQuotes = true

	// setInterval(() => {
	// 	if (classQuotes.length) {
	// 		activeClassQuote = next(classQuotes, activeClassQuote)
	// 	} else if (theatreQuotes.length) {
	// 		activeTheatreQuote = next(theatreQuotes, activeTheatreQuote)
	// 	} else {
	// 		activeQuote = next(bannerQuotes, activeQuote)
	// 	}
	// }, 12000)

	onMount(() => {
		// disable after one cycle
		setTimeout(() => {
			showQuotes = false
		}, 12000)
	})
</script>

{#if showQuotes}
	{#if classQuotes.length}
		{#each [activeClassQuote] as quote (quote)}
			<div
				class:active={activeClassQuote === quote}
				class="qb-wrap"
				in:fly={{ x: 10, duration: 600, easing: sineInOut, delay: 4000 }}
				out:fly={{ x: 10, duration: 500, easing: sineInOut }}
			>
				<div class="quote-banner">
					<svg width="392.83" height="153.61" viewbox="0 0 392.83 153.61">
						<path
							fill="#fff"
							d="M392.62 0H0l35.47 56.53L0 113.06h313.39l8.77 29.42-.02.1 70.48
						11.03v-6.07l-57.13-8.95 57.13-16.79v-6.26l-63.11
						18.56-3.3.97-6.56-22.01h72.97v-6H10.85l31.7-50.53L10.85 6h381.77V0"
						/>
						<path
							fill="#6a2d8c"
							d="M392.62 147.54V121.8l-57.13 16.79 57.13 8.95"
						/>
						<path
							fill="#6a2d8c"
							d="M326.65 113.06h-7l6.56 22.01 3.3-.97 63.11-18.56v-2.48h-65.97"
						/>
						<path
							fill="#6a2d8c"
							d="M392.62 6H10.85l31.7 50.53-31.7 50.53h381.98V6h-.21"
						/>
					</svg>
					<div>
						<span>{quote.quote}</span>
						{#if quote.author}
							<p>-{quote.author}</p>
						{/if}
					</div>
				</div>
			</div>
		{/each}
	{:else if theatreQuotes.length}
		{#each [activeTheatreQuote] as quote (quote)}
			<div
				class:active={activeTheatreQuote === quote}
				class="qb-wrap"
				in:fly={{ x: 10, duration: 600, easing: sineInOut, delay: 4000 }}
				out:fly={{ x: 10, duration: 500, easing: sineInOut }}
			>
				<div class="quote-banner">
					<svg width="392.83" height="153.61" viewbox="0 0 392.83 153.61">
						<path
							fill="#fff"
							d="M392.62 0H0l35.47 56.53L0 113.06h313.39l8.77 29.42-.02.1 70.48
						11.03v-6.07l-57.13-8.95 57.13-16.79v-6.26l-63.11
						18.56-3.3.97-6.56-22.01h72.97v-6H10.85l31.7-50.53L10.85 6h381.77V0"
						/>
						<path
							fill="#6a2d8c"
							d="M392.62 147.54V121.8l-57.13 16.79 57.13 8.95"
						/>
						<path
							fill="#6a2d8c"
							d="M326.65 113.06h-7l6.56 22.01 3.3-.97 63.11-18.56v-2.48h-65.97"
						/>
						<path
							fill="#6a2d8c"
							d="M392.62 6H10.85l31.7 50.53-31.7 50.53h381.98V6h-.21"
						/>
					</svg>
					<div>
						<span>{quote.quote}</span>
						{#if quote.author}
							<p>-{quote.author}</p>
						{/if}
					</div>
				</div>
			</div>
		{/each}
	{:else}
		{#each [activeQuote] as quote (quote)}
			<div
				class:active={activeQuote === quote}
				class="qb-wrap"
				in:fly={{ x: 10, duration: 600, easing: sineInOut, delay: 4000 }}
				out:fly={{ x: 10, duration: 500, easing: sineInOut }}
			>
				<div class="quote-banner">
					<svg width="392.83" height="153.61" viewbox="0 0 392.83 153.61">
						<path
							fill="#fff"
							d="M392.62 0H0l35.47 56.53L0 113.06h313.39l8.77 29.42-.02.1 70.48
						11.03v-6.07l-57.13-8.95 57.13-16.79v-6.26l-63.11
						18.56-3.3.97-6.56-22.01h72.97v-6H10.85l31.7-50.53L10.85 6h381.77V0"
						/>
						<path
							fill="#6a2d8c"
							d="M392.62 147.54V121.8l-57.13 16.79 57.13 8.95"
						/>
						<path
							fill="#6a2d8c"
							d="M326.65 113.06h-7l6.56 22.01 3.3-.97 63.11-18.56v-2.48h-65.97"
						/>
						<path
							fill="#6a2d8c"
							d="M392.62 6H10.85l31.7 50.53-31.7 50.53h381.98V6h-.21"
						/>
					</svg>
					<div>
						<span>{quote.quote}</span>
						{#if quote.author}
							<p>-{quote.author}</p>
						{/if}
					</div>
				</div>
			</div>
		{/each}
	{/if}
{/if}
